export default __webpack_public_path__ + "static/media/poster-sdg-15.4255b9a3.png";